import { render, staticRenderFns } from "./RendezVousMedicaux.vue?vue&type=template&id=1f2a379b&scoped=true&"
import script from "./RendezVousMedicaux.vue?vue&type=script&lang=ts&"
export * from "./RendezVousMedicaux.vue?vue&type=script&lang=ts&"
import style0 from "./RendezVousMedicaux.vue?vue&type=style&index=0&id=1f2a379b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2a379b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VCard,VCardActions,VCol,VDivider,VRow,VSubheader})
